var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfternoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{opacity:0.2;fill:none;stroke:currentColor;stroke-width:5.000000e-02;stroke-miterlimit:10;} .st1{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.9,16.4c1.2,0.8,2.9,0.8,4.1,0c0.6-0.4,1.3-0.4,1.9,0c1.2,0.8,2.9,0.8,4.1,0c0.6-0.4,1.3-0.4,1.9,0 c0.6,0.4,1.3,0.6,2.1,0.6s1.4-0.2,2.1-0.6l1.5-1c0.5-0.3,0.6-0.9,0.3-1.4c-0.3-0.5-0.9-0.6-1.4-0.3l-1.5,1 c-0.5,0.3-1.1,0.4-1.7,0.1c0.3-0.6,0.5-1.2,0.6-1.8c0,0,0.1,0,0.1,0h2c0.6,0,1-0.4,1-1s-0.4-1-1-1h-2c0,0-0.1,0-0.1,0 c-0.2-0.9-0.5-1.8-1-2.5c0,0,0.1,0,0.1,0L18.4,7c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-1.4,1.4c0,0,0,0.1,0,0.1 c-0.7-0.5-1.6-0.9-2.5-1c0,0,0-0.1,0-0.1V4c0-0.6-0.4-1-1-1s-1,0.4-1,1v2c0,0,0,0.1,0,0.1c-0.9,0.2-1.8,0.5-2.5,1c0,0,0-0.1,0-0.1 L7,5.6c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l1.4,1.4c0,0,0.1,0,0.1,0c-0.5,0.7-0.9,1.6-1,2.5c0,0-0.1,0-0.1,0H4c-0.6,0-1,0.4-1,1 s0.4,1,1,1h2c0,0,0.1,0,0.1,0c0.1,0.6,0.3,1.3,0.6,1.8c-0.5,0.3-1.2,0.2-1.7-0.1l-1.5-1c-0.5-0.3-1.1-0.2-1.4,0.3 c-0.3,0.5-0.2,1.1,0.3,1.4L3.9,16.4z M12,8c2.2,0,4,1.8,4,4c0,0.8-0.2,1.5-0.6,2.1c-0.8-0.1-1.7,0.1-2.4,0.6 c-0.6,0.4-1.3,0.4-1.9,0c-0.7-0.5-1.6-0.7-2.4-0.6C8.2,13.5,8,12.8,8,12C8,9.8,9.8,8,12,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4,16.7l-1.5,1c-0.6,0.4-1.3,0.4-1.9,0c-1.2-0.8-2.9-0.8-4.1,0c-0.6,0.4-1.3,0.4-1.9,0c-1.2-0.8-2.9-0.8-4.1,0 c-0.6,0.4-1.3,0.4-1.9,0l-1.5-1c-0.5-0.3-1.1-0.2-1.4,0.3c-0.3,0.5-0.2,1.1,0.3,1.4l1.5,1c1.2,0.8,2.9,0.8,4.1,0 c0.6-0.4,1.3-0.4,1.9,0c1.2,0.8,2.9,0.8,4.1,0c0.6-0.4,1.3-0.4,1.9,0c0.6,0.4,1.3,0.6,2.1,0.6s1.4-0.2,2.1-0.6l1.5-1 c0.5-0.3,0.6-0.9,0.3-1.4C21.5,16.5,20.9,16.4,20.4,16.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfternoon);
export default __webpack_public_path__ + "static/media/afternoon.562b9b241c490706fb8b2e3b0fcf1633.svg";
export { ForwardRef as ReactComponent };